/**
 * PSEA assessment titles are auto-generated from the selected contractor's
 * name. These helpers produce the display preview shown in the (disabled)
 * title field on the form. The backend is the source of truth and generates
 * the persisted title on create/update.
 */

// SelectContractor option labels are formatted as "Name ( ACRONYM )".
export const contractorNameFromLabel = (label?: string) =>
  (label || "").split(" ( ")[0].trim();

export const buildPseaTitle = (contractorName?: string) =>
  contractorName ? `PSEA Assessment for ${contractorName}` : "";
